// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".msg-text{display:block;width:60px;font-size:12px;text-align:center;cursor:pointer}.msg-text.display{color:#ccc}", ""]);
// Exports
module.exports = exports;
